import React, { useState, useEffect } from "react";
import axiosMain from "../http/axiosMain";
// import { Check } from "lucide-react";
import {
  Box,
  Typography,
  Button,
  Grid,
  Paper,
  ToggleButton,
  ToggleButtonGroup,
  Card,
  CardContent,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import "../Brand/../Assets/css/index.css";
import insocialorbitlog from "../Assets/Img/insocialorbitlog.svg";
import { Check } from "lucide-react";


export default function SubScriPtionMethod() {
  const navigate = useNavigate();

  const [billingCycle, setBillingCycle] = useState("monthly");
  const [hoveredButton, setHoveredButton] = useState(null);
  const [subscriptionPlans, setSubscriptionPlans] = useState([]);
  const CurrentPlanType = localStorage.getItem("PlanType");

  useEffect(() => {

    const fetchPlans = async () => {
      try {
        const role = localStorage.getItem("userType"); // or get from context/state
        // or get from context/state
        const roleId = role === "brand" ? 1 : 2;

        const response = await axiosMain.get(
          `/api/subscription/subscription-plan?role_id=${roleId}`
        );
        if (response.data.status) {
          setSubscriptionPlans(response.data.data);
        }
      } catch (error) {
        console.error("Failed to fetch subscription plans", error);
      }
    };

    fetchPlans();
  }, []);

  const handleToggle = (_, newCycle) => {
    if (newCycle) setBillingCycle(newCycle);
  };

  const handleRazorpayPayment = async (plan) => {
    const { discounted, original } = getPrice(plan);
    const amountToPay = discounted !== null ? discounted : original;

    const options = {
      key: "rzp_test_pK3Coo0TBxuw2S", // replace with your actual key
      amount: amountToPay * 100, // in paise
      currency: "INR",
      name: "Insocial Orbit",
      description: `${plan.plan_type} Subscription`,
      image: insocialorbitlog,
      handler: async function (response) {
        const { razorpay_payment_id, razorpay_order_id, razorpay_signature } = response;

        // Log the values for debugging
        console.log("Razorpay Payment Response:",response);
        console.log("razorpay_payment_id:", razorpay_payment_id);
        console.log("razorpay_order_id:", razorpay_order_id);
        console.log("razorpay_signature:", razorpay_signature);

        try {
          const verifyRes = await axiosMain.post("/api/payment/verification", {
            razorpay_payment_id,
            razorpay_order_id,
            razorpay_signature,
          });

          if (verifyRes.data.status) {
            NavigatePage();
          } else {
            alert("Payment verification failed.");
          }
        } catch (error) {
          console.error("Verification API error:", error);
          alert("Something went wrong during verification.");
        }
      },
      prefill: {
        name: "Test User",
        email: "test@example.com",
        contact: "9999999999",
      },
      notes: {
        plan_id: plan.razorpay_plan_id,
      },
      theme: {
        color: "#62a37e",
      },
    };

    const razorpay = new window.Razorpay(options);
    razorpay.open();
  };

  const getPrice = (plan) => {
    const price =
      billingCycle === "monthly" ? plan.monthly_price : plan.yearly_price;

    if (plan.flag_discount_active) {
      const discounted = price - (price * plan.discount) / 100;
      return {
        original: price,
        discounted: Math.round(discounted),
      };
    }

    return { original: price, discounted: null };
  };

  const getButtonText = (planType) => {
    if (planType === "Starter") return "Your Current Plan";
    if (planType === "Plus") return "Upgrade to Plus";
    if (planType === "Pro") return "Talk to Sales";
    return "Subscribe";
  };

  const NavigatePage = () => {
    const isBrandHome = localStorage.getItem("navigateBrandHome");

    if (isBrandHome) {
      navigate("/brand-home");
    } else {
      navigate(-1);
    }
  }

  const planOrder = {
    Starter: 0,
    Pro: 1,
    Enterprise: 2,
  };

  const renderCard = (plan) => {
    const { original, discounted } = getPrice(plan);
    const isDisabled = planOrder[plan.plan_type] <= planOrder[CurrentPlanType];

    return (
      <Box
        sx={{
          px: 3,
          py: 4,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
        }}
        key={plan.subscription_id}
      >
        {/* Plan Title */}
        {/* Title and 'Current Plan' badge */}
        <Box display="flex" alignItems="center" gap={1}>
          <Typography
            variant="h6"
            fontWeight="600"
            sx={{
              fontFamily: "Poppins, sans-serif",
              color: "#1d1d1d"
            }}
          >
            {plan.plan_type}
          </Typography>

          {plan.plan_type === CurrentPlanType && (
            <Box
              sx={{
                backgroundColor: "#6B8E76",
                color: "#FFFFFF",
                fontSize: "12px",
                fontWeight: 500,
                px: 1.5,
                py: "2px",
                borderRadius: "999px",
                fontFamily: "Inter, sans-serif",
              }}
            >
              Current Plan
            </Box>
          )}
        </Box>

        {/* Price Section */}
        <Box display="flex" flexDirection="column" gap={1} mb={2}>
          {discounted !== null ? (
            <Typography
              variant="body2"
              sx={{
                color: "#a1a1a1",
                textDecoration: "line-through",
                fontWeight: 500,
                fontFamily: "Inter",
              }}
            >
              ₹{original}
            </Typography>
          ) : (
            <Typography
              variant="body2"
              sx={{
                color: "#a1a1a1",
                textDecoration: "line-through",
                fontWeight: 500,
                fontFamily: "Inter",
              }}
            >
              {/* ₹{original} */}
              <Typography sx={{ height: '18px' }}></Typography>
            </Typography>
          )}

          <Box display="flex" alignItems="center" gap={1}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                fontFamily: "Poppins,sans-serif",
                color: "#000",
              }}
            >
              ₹{discounted !== null ? discounted : original}
            </Typography>

            {discounted !== null && (
              <Typography
                variant="caption"
                sx={{
                  backgroundColor: "#f5f5f5",
                  color: "#000",
                  fontWeight: 600,
                  px: 1,
                  borderRadius: "4px",
                  fontSize: "12px",
                }}
              >
                -{plan.discount}%
              </Typography>
            )}
          </Box>

          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontFamily: "Poppins" }}
          >
            {plan.description}
          </Typography>
        </Box>

        {/* Features List */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1.2,
            mt: 2,
            flexGrow: 1,
          }}
        >
          {plan.features &&
            plan.features.map((feature, index) => (
              <Box key={index} sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
                <Box
                  sx={{
                    mt: "2px",
                    width: 16,
                    height: 16,
                    borderRadius: "2px",
                    backgroundColor: "#f5f5f5",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <Check color="#6B8E76" size={20} />
                </Box>
                <Typography
                  variant="body2"
                  sx={{
                    fontFamily: "Inter",
                    wordBreak: "break-word",
                    flex: 1,
                  }}
                >
                  {feature}
                </Typography>
              </Box>
            ))}
        </Box>

        {/* Subscribe Button - always at bottom */}
        <Box mt="auto" pt={3}>
          <Button
            fullWidth
            variant="outlined"
            disabled={isDisabled}
            sx={{
              color: isDisabled ? "#A0A0A0" : "#6B8E76",
              fontWeight: 600,
              fontSize: '14px',
              borderRadius: "8px",
              textTransform: "none",
              fontFamily: 'Poppins,sans-serif',
              py: 1.2,
              borderColor: isDisabled ? "#E0E0E0" : "#6B8E76",
              backgroundColor: "transparent",
              '&.Mui-disabled': {
                borderColor: '#E0E0E0 !important',
                backgroundColor: 'transparent !important',
                opacity: 1,
                cursor: 'not-allowed',
              },
            }}
            onClick={() => handleRazorpayPayment(plan)}
          >
            {plan.plan_type === CurrentPlanType
              ? `Start ${plan.plan_type} Plan`
              : getButtonText(plan.plan_type)}
          </Button>

        </Box>
      </Box>
    );
  };

  return (
    <Box sx={{ p: 4 }}>
      <button className="button-back mb-1" onClick={() => NavigatePage()}>
        &lt; Back
      </button>

      <Card
        sx={{
          maxWidth: "90%",
          mx: "auto",
          boxShadow: 0,
          borderRadius: 2,
          p: 2,
        }}
      >
        <CardContent sx={{ mt: 3 }}>
          <Box textAlign="center" mb={4}>
            <Typography variant="h5" fontWeight="bold" gutterBottom>
              Subscribe to Use This Feature
            </Typography>
            <Typography variant="body1" color="text.secondary" mb={3} pb={5}>
              You Have to Upgrade Your Plan to Use This Feature
            </Typography>
            {/* <ToggleButtonGroup
              value={billingCycle}
              exclusive
              onChange={handleToggle}
              sx={{
                backgroundColor: "#f1f4f4", // outer background
                borderRadius: "999px",      // fully rounded
                padding: "4px",
                width: "fit-content",
                mx: "auto",                 // center align
              }}
            >
              <ToggleButton
                value="monthly"
                disableRipple
                sx={{
                  textTransform: "none",
                  borderRadius: "999px",
                  px: 5,
                  py: 1.2,
                  fontWeight: 700,
                  fontFamily: "Inter,sans-serif",
                  fontSize: "12px",
                  color: "#5a5a5a",
                  "&.Mui-selected": {
                    backgroundColor: "#628e75", // your green
                    color: "#ffffff",
                    borderRadius: "999px",
                  },
                  "&.Mui-selected:hover": {
                    backgroundColor: "#628e75",
                  },
                  border: 'none !important'
                }}
              >
                Monthly
              </ToggleButton>

              <ToggleButton
                value="yearly"
                disableRipple
                sx={{
                  textTransform: "none",
                  borderRadius: "999px",
                  px: 5,
                  py: 1.2,
                  fontWeight: 700,
                  fontFamily: "Inter",
                  fontSize: "14px",
                  color: "#5a5a5a",
                  "&.Mui-selected": {
                    backgroundColor: "#628e75",
                    color: "#ffffff",
                    borderRadius: "999px",
                  },
                  "&.Mui-selected:hover": {
                    backgroundColor: "#628e75",
                  },
                  border: 'none !important'
                }}
              >
                Yearly
              </ToggleButton>
            </ToggleButtonGroup> */}

          </Box>

          <Grid
            container
            justifyContent="center"
            sx={{
              border: "0.85px solid #e0e0e0",
              borderRadius: "12px",
              overflow: "hidden",
            }}
          >
            {subscriptionPlans.map((plan, index) => (
              <Grid
                item
                xs={12}
                sm={4}
                key={plan.subscription_id}
                sx={{
                  borderRight:
                    index !== subscriptionPlans.length - 1
                      ? "0.85px solid #e0e0e0"
                      : "none",
                }}
              >
                {renderCard(plan)}
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
}
